import { createAction, handleActions } from 'redux-actions'

const openSubOrderModal = createAction('SCREENS/SUB_PROJECT/SUB_ORDERS/OPEN_SUB_ORDER_MODAL')
const closeSubOrderModal = createAction('SCREENS/SUB_PROJECT/SUB_ORDERS/CLOSE_SUB_ORDER_MODAL')

const defaultState = {
  show: false,
}

const reducer = handleActions(
  {
    [openSubOrderModal]: (state, { payload }) => ({
      ...payload,
      show: true,
    }),
    [closeSubOrderModal]: () => defaultState,
  },
  defaultState,
)

export { openSubOrderModal, closeSubOrderModal, reducer }
